
const InquiryCategoryType = Symbol();

export class InquiryCategory {

    [InquiryCategoryType]: any;
    readonly value: string;

    private constructor(
        value: string
    ) {
        this.value = value;
    }

    static fromString(value: string) {
        return new InquiryCategory(value);
    }
}
